export enum DataHooks {
  IMAGE = 'card-image',
  INFO = 'card-info',
}
